import jwtDecode from 'jwt-decode';
import { LOGOUT } from 'Reducers/auth/types';
import log from 'Utilities/log';
import { clearCookie, clearSession, getCookie, getObject, getSessionObject, removeObject, setCookie, setSessionObject, } from 'Utilities/storage';
import mediator from './mediator';
import { store } from './store';
export const persistAuthSession = (session) => {
    try {
        setSessionObject('authSession', session);
        setCookie('authSession', session, session.authTicket.expires);
        // remove old session from localStorage
        const storedSession = getObject('authSession');
        if (storedSession) {
            removeObject('authSession');
        }
    }
    catch (err) {
        log.error(err);
    }
};
export const getAuthSession = () => {
    try {
        // Try to get our token from session storage first or fallback to cookies
        let authSession = getSessionObject('authSession');
        if (!authSession) {
            authSession = getCookie('authSession');
        }
        return authSession;
    }
    catch (e) {
        return null;
    }
};
export const updateSessionLanguage = (language) => {
    setSessionObject('language', language);
};
export const getSessionLanguage = () => {
    return getSessionObject('language');
};
export const logout = () => {
    clearSession();
    clearCookie('authSession');
    store.dispatch({ type: LOGOUT });
    mediator.publish('router:navigate', '/login');
};
export const removeAuthSession = () => {
    clearSession();
    clearCookie('authSession');
};
export const createAuthSession = (token, patient) => {
    const decodedToken = jwtDecode(token);
    return {
        user: {
            id: decodedToken.id,
            firstName: patient.firstName,
            lastName: patient.lastName,
            email: patient.email,
            country: patient.country,
            uiLanguage: patient.language,
            communicationLanguage: '',
            accountType: '',
            uom: '',
            dateFormat: '',
            timeFormat: '',
            emailDay: [],
        },
        authTicket: {
            token,
            expires: decodedToken.exp,
            duration: decodedToken.exp,
        },
    };
};
